import { classnames } from "lib/helpers";
import { Children, cloneElement, useRef, useState } from "react";

export function Tab({ children, show }) {
  return <div className={classnames("tb-p", { s: show })}>{children}</div>;
}

export function RenderTab({ children, tab }) {
  const initialized = useRef([]);
  return Children.map(children, (child, index) => {
    const isCurrentTab = tab === index;
    const isUninitialized = !initialized.current.includes(index);
    if (child.props.lazy && isUninitialized) {
      if (!isCurrentTab) {
        return null;
      } else if (isCurrentTab) {
        initialized.current.push(index);
      }
    }
    return cloneElement(child, { show: isCurrentTab });
  });
}

export default function Tabs({ children, defaultTab = 0, fill, icons }) {
  const [tab, setTab] = useState(defaultTab);
  return (
    <div className={classnames("tb", { f: fill, is: icons })}>
      <div className="tb-c">
        {Children.map(children, ({ props }, i) => {
          return (
            <div
              onClick={() => setTab(i)}
              className={classnames("tb-t", { a: tab === i })}
              role="tab"
            >
              {typeof props.title === "function"
                ? props.title(tab === i)
                : props.title}
            </div>
          );
        })}
      </div>
      <RenderTab {...{ tab }}>{children}</RenderTab>
    </div>
  );
}
